module.exports = __webpack_public_path__ + "static/media/nursery_1.aafdd282.png";